import request from '@/utils/request'
import axios from 'axios'

export function PersonalRegister(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/Register/PersonalRegister',
        method: 'post',
        data
    })
}

export function EnterprisesRegister(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/Register/EnterprisesRegister',
        method: 'post',
        data
    })
}


export function GetEnterpriseNameByName(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/Register/GetEnterpriseNameByName',
        method: 'post',
        params: data
    })
}


export function GetEnterpriseDeptNameByID(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/Register/GetEnterpriseDeptNameByID',
        method: 'get',
        params: data
    })
}


export function GetEnterprisestypeList() {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/Register/GetEnterprisestypeList',
        method: 'post'
    })
}


export function updateImage(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/Register/updateImage',
        method: 'post',
        data,
        contentType: "multipart/form-data"
    })
}


export function SendMessage(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/Register/SendMessage',
        method: 'post',
        params: data
    })
}
/**
 * 忘记密码
 * @param {phone} 用户手机号
 * @param {code} 验证码 
 * @param {password} 密码 
 */
export function forgetPassword(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/Register/forgetpassword',
        method: 'post',
        params: data

    })
}
//微信授权接口
export function WeChatAuth(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/userauth/WeChatAuth',
        method: 'post',
        params: data
    })
}

//检查手机号是否注册
export function CheckPhone(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/userauth/CheckPhone',
        method: 'post',
        params: data
    })
}

//绑定授权手机号
export function BindAuthPhone(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/userauth/BindAuthPhone',
        method: 'post',
        params: data
    })
}

//获取APP扫码登录的二维码
export function GetQRCoder(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/Register/GetQRCoder',
        method: 'post',
        params: data
    })
}

//检查用户是否注册
export function CheckUserRegistration(data) {
    return request({
        baseURL: process.env.VUE_APP_Dzy,
        url: '/api/Register/CheckUserRegistration',
        method: 'post',
        params: data
    })
}

//查询APP有没有扫码
// export function CheckQRCoderScanning(data) {
//     return request({
//         baseURL: process.env.VUE_APP_Dzy,
//         url: '/api/Register/CheckQRCoderScanning',
//         method: 'post',
//         params: data
//     })
// }
export function CheckQRCoderScanning(data) {
    return axios.post(`${process.env.VUE_APP_Dzy}api/Register/CheckQRCoderScanning`,null,{
            params: data,
            headers: {'ClientType': 1, 'ModuleId':"",'ClientIp':""}
        }
    )
}


// 获取验证码
export function getCaptcha() {
  return request({
    baseURL: process.env.VUE_APP_Dzy,
    url: '/api/Register/generate',
    method: 'get'
  })
}

// 验证验证码
export function verifyCaptcha(data) {
  return request({
    baseURL: process.env.VUE_APP_Dzy,
    url: '/api/Register/verifyCaptcha',
    method: 'post',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/api/Register.js